import _ from 'lodash';
import moment from 'moment';
import {
  AUDIENCE_MANAGER_FIELD_MAPPING,
  CHANGE_LOG_BOOLEAN_FIELDS,
  CHANGE_LOG_TIMESTAMP_FIELDS,
} from '../../constants/index';

/**
 * Convert current createdAt to specific 'MM/DD/YYYY HH:mm A' format along with split (date-time) functionality
 * @param createdAt : string
 * @param isSplitTime : boolean
 * @returns : render object
 */
export const convertToDateTime = (createdAt: string, isSplitTime = false) => {
  if (!createdAt) return '';
  const utcMoment = moment.utc(createdAt);
  const localMoment = utcMoment.local();
  const dateTime = moment(localMoment).format('MM/DD/YYYY HH:mm A');
  if (dateTime) {
    if (!isSplitTime) return dateTime;
    const splitedTime = dateTime.split(' ');
    return (
      <>
        <span>{splitedTime[0]}</span>
        <br />
        <span>{`${splitedTime[1]} ${splitedTime[2]}`}</span>
      </>
    );
  }

  return '';
};

const formatBoolean = (value: any) =>
  value === 1 || value === true ? 'Yes' : 'No';
const formatDate = (value: any) =>
  value ? new Date(value).toLocaleDateString() : 'N/A';
const formatArray = (value: any) =>
  Array.isArray(value) ? JSON.stringify(value, null, 2) : value;
const formatAudienceType = (value: string) =>
  value === 'CUSTOM' ? 'Custom Audience' : 'Audience';

const prepareChangedFields = (
  previousData: any,
  newData: any,
  changedFields: any
) => {
  try {
    return changedFields.map((field: any) => {
      let previousValue, newValue;

      switch (true) {
        case CHANGE_LOG_BOOLEAN_FIELDS.includes(field):
          previousValue = formatBoolean(previousData[field]);
          newValue = formatBoolean(newData[field]);
          break;
        case CHANGE_LOG_TIMESTAMP_FIELDS.includes(field):
          previousValue = formatDate(previousData[field]);
          newValue = formatDate(newData[field]);
          break;
        case field === 'audience_type':
          previousValue = formatAudienceType(previousData[field]);
          newValue = formatAudienceType(newData[field]);
          break;
        default:
          previousValue = formatArray(previousData[field]);
          newValue = formatArray(newData[field]);
      }

      return { field, previousValue, newValue };
    });
  } catch (e) {
    console.log('error in prepareChangedFields:', e);
    throw e;
  }
};

export const getChangedFields = (
  previousData: string,
  newData: string,
  changedFields: any
) => {
  try {
    const prevObj = JSON.parse(previousData);
    const newObj = JSON.parse(newData);
    return prevObj === null || newObj === null
      ? []
      : prepareChangedFields(prevObj, newObj, changedFields);
  } catch (e) {
    console.log('error in getChangedFields:', e);
    throw e;
  }
};

export const getFieldMapping = () => {
  return AUDIENCE_MANAGER_FIELD_MAPPING;
};
